<div class='overview-layout' *ngIf="showOverview">
  <app-overview [ngClass]="classVal" class="booking-summary fadeInLeft" *ngIf="showOverview"></app-overview>
</div>
